import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { HelmetProvider } from 'react-helmet-async';

// Scroll to top component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import TrademarkRegistration from "./pages/TrademarkRegistration";
import CopyrightRegistration from "./pages/CopyrightRegistration";
import CompanyFormation from "./pages/CompanyFormation";
import TrademarkSearch from "./pages/TrademarkSearch";
import AmazonBrandRegistry from "./pages/AmazonBrandRegistry";
import LandingPage from "./pages/LandingPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import ThankYou from "./pages/ThankYou";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Landing Page Route - No Header/Footer */}
            <Route path="/lp" element={<LandingPage />} />
            
            {/* Main Routes with Header/Footer */}
            <Route path="*" element={
              <>
                <Header />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/services/trademark-registration" element={<TrademarkRegistration />} />
                  <Route path="/services/copyright-registration" element={<CopyrightRegistration />} />
                  <Route path="/services/company-formation" element={<CompanyFormation />} />
                  <Route path="/services/trademark-search" element={<TrademarkSearch />} />
                  <Route path="/services/amazon-brand-registry" element={<AmazonBrandRegistry />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/thank-you" element={<ThankYou />} />
                  <Route path="/application/step-one" element={<ThankYou />} />
                  <Route path="/application/main" element={<ThankYou />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/terms-of-service" element={<TermsOfService />} />
                </Routes>
                <Footer />
              </>
            } />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
